<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useUiStore } from "@/store";

const uiStore = useUiStore();
const { loading } = storeToRefs(uiStore);
</script>

<template>
  <div v-if="loading" class="page-loader loading-page bar"></div>
</template>

<style lang="scss" scoped>
@import "@/styles/colors_mds.scss";

.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000000;
  pointer-events: none;
  opacity: 0;
  transition:
    width 1350ms ease-in-out,
    opacity 350ms linear,
    left 50ms ease-in-out;
}

.bar {
  background-color: $wrapper--mds_brand_appearance_secondary_default_background-color;
  height: 5px;
  width: 100%;
}

.loading-page {
  opacity: 1;
  animation: loading 2000ms ease-in-out;
  animation-iteration-count: infinite;
}

@keyframes loading {
  0% {
    width: 0;
    left: 0;
  }
  50% {
    width: 100%;
    left: 0;
  }
  100% {
    width: 100%;
    left: 100%;
  }
}
</style>
